import React, { Component } from 'react'
import { css } from 'emotion'
import { NavLink } from 'react-router-dom'
import { Text, MediaQuery } from 'components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { COLOR, MEDIA_QUERY } from 'styles'

class IconLink extends Component {
  render() {
    const { className, children, label, icon, ...props } = this.props
    const classNames = css(styles.link, className)
    return (
      <NavLink
        className={classNames}
        activeStyle={{
          color: COLOR.red,
        }}
        {...props}
      >
        <FontAwesomeIcon className={styles.icon} icon={icon} />
        <MediaQuery maxWidth={767}>
          {matches => {
            if (matches) {
              return (
                <Text heading h5 className={styles.label}>
                  {label}
                </Text>
              )
            }
            return (
              <Text heading h4 className={styles.label}>
                {label}
              </Text>
            )
          }}
        </MediaQuery>
      </NavLink>
    )
  }
}

const styles = {
  link: css({
    color: COLOR.white,
    textDecoration: 'none',
    cursor: 'pointer',
    '&:hover': {
      transform: 'scale(1.05)',
    },
  }),
  icon: css({
    marginRight: '1rem',
    fontSize: '2.5rem',
    [MEDIA_QUERY.SM]: {
      fontSize: '1.5rem',
    },
  }),
}

export default IconLink
